"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareUpgradeStatus = exports.DatabaseUpgradeError = exports.DatabaseUpgradeProgress = exports.DatabaseUpgradeStatus = exports.JwtSecretUpdateError = exports.JwtSecretUpdateProgress = exports.JwtSecretUpdateStatus = exports.WalgUpdateType = exports.InfraUpdateType = exports.ProjectDiskGrowth = exports.ProjectEvents = void 0;
var ProjectEvents;
(function (ProjectEvents) {
    ProjectEvents["ProjectPaused"] = "project.paused";
    ProjectEvents["ProjectRestored"] = "project.restored";
    ProjectEvents["ProjectRestoredFromLogicalBackup"] = "project.restored_from_logical_backup";
    ProjectEvents["ProjectRestoredFromPitr"] = "project.restored_from_pitr";
    ProjectEvents["ProjectFailedRestorationFromPitr"] = "project.failed_restoration_from_pitr";
    ProjectEvents["ProjectPendingShutdown"] = "project.pending_shutdown_notification";
    ProjectEvents["ProjectShutdownEligible"] = "project.shutdown_eligible";
    ProjectEvents["ProjectJwtSecretUpdateStatusChange"] = "project.jwt_secret_update_status_change";
    ProjectEvents["ProjectServiceConfigUpdate"] = "project.service_config_update";
    ProjectEvents["ProjectSansKpsMigrationInitiated"] = "project.sans_kps_migration_initiated";
    ProjectEvents["ProjectSansKpsMigrationCompleted"] = "project.sans_kps_migration_completed";
    ProjectEvents["ProjectDatabaseUpgradeStatusChange"] = "project.database_upgrade_status_change";
    ProjectEvents["ProjectInfrastructureUpdated"] = "project.infra_updated";
    ProjectEvents["PostgresqlRestart"] = "postgresql.restart";
    ProjectEvents["ProjectWalgUpdated"] = "project.walg_updated";
    ProjectEvents["ProjectSubscriptionUpdated"] = "project.subscription_updated";
    ProjectEvents["ProjectDiskGrowth"] = "project.disk_growth";
    ProjectEvents["ProjectSoftwareUpgraded"] = "project.software_upgraded";
})(ProjectEvents = exports.ProjectEvents || (exports.ProjectEvents = {}));
var ProjectDiskGrowth;
(function (ProjectDiskGrowth) {
    ProjectDiskGrowth["DiskExpand"] = "disk_expand";
    ProjectDiskGrowth["FilesystemGrow"] = "fs_grow";
})(ProjectDiskGrowth = exports.ProjectDiskGrowth || (exports.ProjectDiskGrowth = {}));
var InfraUpdateType;
(function (InfraUpdateType) {
    InfraUpdateType["Created"] = "created";
    InfraUpdateType["Resized"] = "resized";
    InfraUpdateType["Deleted"] = "deleted";
})(InfraUpdateType = exports.InfraUpdateType || (exports.InfraUpdateType = {}));
var WalgUpdateType;
(function (WalgUpdateType) {
    WalgUpdateType["Enabled"] = "enabled";
    WalgUpdateType["Changed"] = "changed";
    WalgUpdateType["Disabled"] = "disabled";
})(WalgUpdateType = exports.WalgUpdateType || (exports.WalgUpdateType = {}));
var JwtSecretUpdateStatus;
(function (JwtSecretUpdateStatus) {
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Updating"] = 0] = "Updating";
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Updated"] = 1] = "Updated";
    JwtSecretUpdateStatus[JwtSecretUpdateStatus["Failed"] = 2] = "Failed";
})(JwtSecretUpdateStatus = exports.JwtSecretUpdateStatus || (exports.JwtSecretUpdateStatus = {}));
var JwtSecretUpdateProgress;
(function (JwtSecretUpdateProgress) {
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["Started"] = 0] = "Started";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["RestartedPostgreSQL"] = 1] = "RestartedPostgreSQL";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedAPIServicesConfiguration"] = 2] = "UpdatedAPIServicesConfiguration";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["RestartedAPIServices"] = 3] = "RestartedAPIServices";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedDatabaseAdminAPIConfiguration"] = 4] = "UpdatedDatabaseAdminAPIConfiguration";
    JwtSecretUpdateProgress[JwtSecretUpdateProgress["UpdatedAPIGatewayConfiguration"] = 5] = "UpdatedAPIGatewayConfiguration";
})(JwtSecretUpdateProgress = exports.JwtSecretUpdateProgress || (exports.JwtSecretUpdateProgress = {}));
var JwtSecretUpdateError;
(function (JwtSecretUpdateError) {
    JwtSecretUpdateError[JwtSecretUpdateError["PostgreSQLRestartFailed"] = 0] = "PostgreSQLRestartFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIServicesConfigurationUpdateFailed"] = 1] = "APIServicesConfigurationUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIServicesRestartFailed"] = 2] = "APIServicesRestartFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["DatabaseAdminAPIConfigurationUpdateFailed"] = 3] = "DatabaseAdminAPIConfigurationUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["SupabaseAPIKeyUpdateFailed"] = 4] = "SupabaseAPIKeyUpdateFailed";
    JwtSecretUpdateError[JwtSecretUpdateError["APIGatewayUpdateFailed"] = 5] = "APIGatewayUpdateFailed";
})(JwtSecretUpdateError = exports.JwtSecretUpdateError || (exports.JwtSecretUpdateError = {}));
var DatabaseUpgradeStatus;
(function (DatabaseUpgradeStatus) {
    DatabaseUpgradeStatus[DatabaseUpgradeStatus["Upgrading"] = 0] = "Upgrading";
    DatabaseUpgradeStatus[DatabaseUpgradeStatus["Upgraded"] = 1] = "Upgraded";
    DatabaseUpgradeStatus[DatabaseUpgradeStatus["Failed"] = 2] = "Failed";
})(DatabaseUpgradeStatus = exports.DatabaseUpgradeStatus || (exports.DatabaseUpgradeStatus = {}));
var DatabaseUpgradeProgress;
(function (DatabaseUpgradeProgress) {
    DatabaseUpgradeProgress["Started"] = "1_started";
    DatabaseUpgradeProgress["LaunchedUpgradedInstance"] = "2_launched_upgraded_instance";
    DatabaseUpgradeProgress["DetachedVolumeFromUpgradedInstance"] = "3_detached_volume_from_upgraded_instance";
    DatabaseUpgradeProgress["AttachedVolumeToOriginalInstance"] = "4_attached_volume_to_original_instance";
    DatabaseUpgradeProgress["InitiatedDataUpgrade"] = "5_initiated_data_upgrade";
    DatabaseUpgradeProgress["CompletedDataUpgrade"] = "6_completed_data_upgrade";
    DatabaseUpgradeProgress["DetachedVolumeFromOriginalInstance"] = "7_detached_volume_from_original_instance";
    DatabaseUpgradeProgress["AttachedVolumeToUpgradedInstance"] = "8_attached_volume_to_upgraded_instance";
    DatabaseUpgradeProgress["CompletedUpgrade"] = "9_completed_upgrade";
})(DatabaseUpgradeProgress = exports.DatabaseUpgradeProgress || (exports.DatabaseUpgradeProgress = {}));
var DatabaseUpgradeError;
(function (DatabaseUpgradeError) {
    DatabaseUpgradeError["UpgradedInstanceLaunchFailed"] = "1_upgraded_instance_launch_failed";
    DatabaseUpgradeError["VolumeDetachchmentFromUpgradedInstanceFailed"] = "2_volume_detachchment_from_upgraded_instance_failed";
    DatabaseUpgradeError["VolumeAttachmentToOriginalInstanceFailed"] = "3_volume_attachment_to_original_instance_failed";
    DatabaseUpgradeError["DataUpgradeInitiationFailed"] = "4_data_upgrade_initiation_failed";
    DatabaseUpgradeError["DataUpgradeCompletionFailed"] = "5_data_upgrade_completion_failed";
    DatabaseUpgradeError["VolumeDetachchmentFromOriginalInstanceFailed"] = "6_volume_detachchment_from_original_instance_failed";
    DatabaseUpgradeError["VolumeAttachmentToUpgradedInstanceFailed"] = "7_volume_attachment_to_upgraded_instance_failed";
    DatabaseUpgradeError["UpgradeCompletionFailed"] = "8_upgrade_completion_failed";
})(DatabaseUpgradeError = exports.DatabaseUpgradeError || (exports.DatabaseUpgradeError = {}));
var SoftwareUpgradeStatus;
(function (SoftwareUpgradeStatus) {
    SoftwareUpgradeStatus["Updating"] = "updating";
    SoftwareUpgradeStatus["Updated"] = "updated";
    SoftwareUpgradeStatus["Failed"] = "failed";
})(SoftwareUpgradeStatus = exports.SoftwareUpgradeStatus || (exports.SoftwareUpgradeStatus = {}));
